import { useRelayInfo } from "../../hooks";
import { useSnackbar } from "notistack";
import RelayAPI from "../../../../../api/RelayAPI";
import { Button, TextInput, Typography } from "@monolith-forensics/monolith-ui";
import { useForm } from "@mantine/form";
import { RelayUrl } from "../../../System";
import { SectionContainer } from "./SectionContainer";

export const TenantSlug: React.FC = () => {
  const { relayInfo, refetch } = useRelayInfo();
  const { enqueueSnackbar } = useSnackbar();

  const form = useForm({
    initialValues: {
      tenant_slug: relayInfo?.tenant_slug,
    },
    validate: (values) => {
      const errors: any = {};

      if (!values.tenant_slug) {
        errors.tenant_slug = "This field is required";
        return errors;
      }

      const regex = /^[a-zA-Z0-9-]+$/;

      if (!regex.test(values.tenant_slug)) {
        errors.tenant_slug = "Only letters, numbers, and hyphens are allowed";
      }

      return errors;
    },
  });

  if (!relayInfo) return null;

  const handleUpdate = async () => {
    const validationResults = form.validate();

    if (validationResults.hasErrors) {
      return;
    }

    const { tenant_slug } = form.getValues();

    const verifyResult = await RelayAPI.verifySlug({ tenant_slug });

    if (verifyResult.available === false) {
      form.setErrors({
        tenant_slug: "Slug is already in use",
      });
      return;
    }

    await RelayAPI.updateRelaySlug({
      tenant_slug,
      tenant_uuid: relayInfo.tenant_uuid,
    });

    enqueueSnackbar("Tenant slug updated successfully", {
      variant: "success",
    });

    refetch();
    form.clearErrors();
    form.resetDirty();
  };

  return (
    <SectionContainer>
      <div>
        <Typography variant="h3" display="inline">
          Relay Tenant Slug
        </Typography>
        <div className="message">
          This sets the URL identifier for your Relay tenant.
        </div>
      </div>
      <div className="message">
        Preview:{" "}
        <RelayUrl
          relayInfo={{
            ...relayInfo,
            tenant_slug: form.getValues()?.tenant_slug || "",
          }}
          urlString={true}
        />
      </div>
      <TextInput
        label="Tenant Slug"
        placeholder="Enter a new Tenant slug"
        style={{ maxWidth: 400 }}
        key={form.key("tenant_slug")}
        {...form.getInputProps("tenant_slug")}
      />
      <div>
        <Button
          variant="contained"
          color="primary"
          style={{ marginLeft: "auto" }}
          size="xs"
          onClick={handleUpdate}
          disabled={!form.isDirty()}
        >
          Update Slug
        </Button>
      </div>
    </SectionContainer>
  );
};
